module.exports = __webpack_public_path__ + "static/media/Articles_Hero_Mobile_1.41639f5e.png";